<template>
	<v-container>
		<v-row>
			<v-col
					cols="12"
					sm="10"
					md="8"
					lg="6"
			>
				<v-card>
					<v-toolbar elevation="0">
						<v-toolbar-title v-text="'Акции'" />
						<v-spacer />
						<v-btn
								outlined
								color="green"
								:to="'/stocks/create'"
								v-text="'Добавить акцию'"
						/>
					</v-toolbar>
					<v-data-table
							:headers="headers"
							:items="stocks.data"
							:loading="loading"
							:server-items-length="stocks.meta.total"
							loading-text="Загрузка..."
					>
						<template #item.actions="{ item }">
							<v-tooltip top>
								<template #activator="{ on }">
									<v-btn
											icon
											color="blue"
											v-on="on"
											@click="editStock(item)"
									>
										<v-icon v-text="'mdi-file-edit-outline'" />
									</v-btn>
								</template>

								<span v-text="'Редактировать'" />
							</v-tooltip>
						</template>
					</v-data-table>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	const HEADERS = [
		{
			text: 'Заголовок',
			value: 'title',
		},
		{
			text: 'Слоган',
			value: 'tagline',
		},
		{
			text: 'Действия',
			value: 'actions',
			align: 'end',
		},
	];

	export default {
		name: 'StocksIndex',
		data: () => ({
			loading: false,
			stocks: {
				data: [],
				meta: {
					total: 0,
					current_page: 1,
					per_page: 10,
				},
			},
		}),
		computed: {
			headers() {
				return HEADERS;
			},
		},
		mounted() {
			this.getStocks();
		},
		methods: {
			getStocks(options = {}) {
				if (this.loading) {
					return;
				}
				this.loading = true;

				this.$http.get('/api/v1/stocks', {
					params: {
						...options,
					},
				})
					.then(response => {
						this.stocks = response.data;
					})
					.finally(() => (this.loading = false));
			},
			editStock(stock) {
				this.$router.push(`/stocks/${stock.slug}`);
			},
		},
	};
</script>

<style scoped>

</style>
